import * as React from 'react';
import { Popover, UIText3 } from '@cian/ui-kit';

import * as styles from './styles.css';

export interface IErrorPopoverProps {
  tooltipContent: string;
  children: React.ReactElement;
  wrapWith?: keyof React.JSX.IntrinsicElements;
}

export const ErrorPopover = React.forwardRef<HTMLDivElement, IErrorPopoverProps>(function ErrorPopoverComponent(
  { children, tooltipContent, wrapWith },
  ref,
) {
  return (
    <Popover
      open={Boolean(tooltipContent)}
      content={
        <div className={styles['error-container']}>
          <UIText3 color="current_color">{tooltipContent}</UIText3>
        </div>
      }
      placement={'bottom-start'}
      flip={false}
      preventOverflow={false}
    >
      {wrapWith
        ? React.createElement(wrapWith, { ref }, children)
        : React.cloneElement(children, { ref } as Parameters<typeof React.cloneElement>[1])}
    </Popover>
  );
});

ErrorPopover.displayName = 'ErrorPopover';
